import axios from 'axios';
import store  from '../store';

const rate = {
  getServiceInfo(purchase_id,token) {
    return axios({
      method: "get",
      url: `${process.env.VUE_APP_API_EXP}/domain/rates/${purchase_id}.json?token=${  token}`
    });
  },
  sentService(purchase_id,token,serviceRate) {
    return axios({
      method: "post",
      url: `${process.env.VUE_APP_API_EXP}/domain/rates.json?purchase_id=${purchase_id}&token=${token}`,
      data: { rate: serviceRate }
    })
  }
}
const policie = {
  servicePolicies() {
    return axios({
      method: "get",
      url: `${process.env.VUE_APP_API_EXP}/domain/service_policies?supplier_id=${store.state.customer.supplier.id}`
    });
  }
}
const bannerPopUps = {
  getBanners(trigger) {
    return axios({
      method: "get",
      url: `${process.env.VUE_APP_API_EXP}/domain/content_popups.json?supplier_id=${store.state.customer.supplier.id}&service=${store.state.order.service}&trigger=${trigger}`,
    });
  },
  getUpsellingProducts() {
    return axios({
      method: "get",
      url: `${process.env.VUE_APP_API_EXP}/domain_v2/upselling_products.json?supplier_id=${store.state.customer.supplier.id}&service=${store.state.order.service}&subservice=${store.state.order.subservice}`
    });
  },
  getUpsellingProductsAddToCart() {
    return axios({
      method: "get",
      url: `${process.env.VUE_APP_API_EXP}/domain_v2/upselling_products.json?supplier_id=${store.state.customer.supplier.id}&service=${store.state.order.service}&subservice=${store.state.order.subservice}&trigger=add-products`
    });
  }
}
const delivery = {
  getProductSupplierByProduct () {
    return axios({
      method: "get",
      url: `${process.env.VUE_APP_API_EXP}/domain_v2/product_supplier_by_product/${store.state.shared.productPurchaseId}.json&service=${store.state.order.service}`
    });
  }

}

export {
  rate,
  policie,
  bannerPopUps,
  delivery
}